import React from "react";

import {CloseIcon, UserIcon} from "@pg-design/icons-module";
import {Popover} from "@pg-design/notifications";
import {useUserDevice} from "@pg-mono/user-device";

import * as styles from "./UserIconPopover.module.css";

interface IProps {
    isPopoverActive: boolean;
    onPopoverClose: () => void;
}

export const UserIconPopover = (props: IProps) => {
    const {isMobile} = useUserDevice();

    const onCloseIconClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        props.onPopoverClose();
    };

    return (
        <div className={styles.outerWrapper}>
            <Popover
                type="success"
                arrow
                isActive={props.isPopoverActive}
                popoverPlace="bottom-end"
                appendTo="parent"
                body={
                    <div className={styles.popoverContentWrapperStyle}>
                        Załóż konto i korzystaj z dodatkowego wsparcia w poszukiwaniu mieszkania
                        <CloseIcon size="1.6" className={styles.closeIconStyle} onClick={onCloseIconClick} />
                    </div>
                }
                openOnMount
                arrowClassName={styles.arrowStyle}
                wrapperClassName={styles.popoverWrapperStyle}
            >
                <UserIcon size={isMobile ? "2" : "2.5"} />
            </Popover>
        </div>
    );
};
import React from "react";

import {CloseIcon, UserIcon} from "@pg-design/icons-module";
import {Popover} from "@pg-design/notifications";
import {useUserDevice} from "@pg-mono/user-device";

import * as styles from "./UserIconPopover.module.css";

interface IProps {
    isPopoverActive: boolean;
    onPopoverClose: () => void;
}

export const UserIconPopover = (props: IProps) => {
    const {isMobile} = useUserDevice();

    const onCloseIconClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        props.onPopoverClose();
    };

    return (
        <div className={styles.outerWrapper}>
            <Popover
                type="success"
                arrow
                isActive={props.isPopoverActive}
                popoverPlace="bottom-end"
                appendTo="parent"
                body={
                    <div className={styles.popoverContentWrapperStyle}>
                        Załóż konto i korzystaj z dodatkowego wsparcia w poszukiwaniu mieszkania
                        <CloseIcon size="1.6" className={styles.closeIconStyle} onClick={onCloseIconClick} />
                    </div>
                }
                openOnMount
                arrowClassName={styles.arrowStyle}
                wrapperClassName={styles.popoverWrapperStyle}
            >
                <UserIcon size={isMobile ? "2" : "2.5"} />
            </Popover>
        </div>
    );
};
